import { jsx as _jsx } from "react/jsx-runtime";
export default function ScrollOverlay({ direction = "horizontal", className = "" }) {
    switch (direction) {
        case "horizontal": {
            return (_jsx("div", { className: `
            te-w-[14px] te-h-full te-bg-gradient-to-r te-from-transparent te-to-colorBgBase
            ${className}
          ` }));
        }
        case "vertical": {
            return (_jsx("div", { className: `
            te-h-[14px] te-w-full te-bg-gradient-to-b te-from-transparent te-to-colorBgBase
            ${className}
          ` }));
        }
    }
}
